import { TransformWrapper, TransformComponent } from '@kokarn/react-zoom-pan-pinch';
import './ZoomableMap.css';

// Shared wrapper for every state map: pinch/scroll/double-click zoom plus an
// on-screen +/-/reset control cluster. Standardizes the zoom config across all
// maps (previously some used explicit props, others the library defaults).
const ZoomableMap = ({ children, contentClassName }) => {
  const isMobile =
    typeof window !== 'undefined' &&
    window.matchMedia('(max-width: 767px)').matches;

  return (
    <TransformWrapper
      initialScale={isMobile ? 1.6 : 1}
      minScale={0.5}
      maxScale={6}
      doubleClick={{ disabled: false, mode: 'toggle' }}
    >
      {({ zoomIn, zoomOut, resetTransform }) => (
        <>
          <div className="map-zoom-controls">
            <button
              type="button"
              className="map-zoom-btn"
              aria-label="Zoom in"
              onClick={() => zoomIn()}
            >
              +
            </button>
            <button
              type="button"
              className="map-zoom-btn"
              aria-label="Zoom out"
              onClick={() => zoomOut()}
            >
              −
            </button>
            <button
              type="button"
              className="map-zoom-btn"
              aria-label="Reset zoom"
              onClick={() => resetTransform()}
            >
              ⤢
            </button>
          </div>
          <TransformComponent>
            {contentClassName ? (
              <div className={contentClassName}>{children}</div>
            ) : (
              children
            )}
          </TransformComponent>
        </>
      )}
    </TransformWrapper>
  );
};

export default ZoomableMap;
